(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-with-image-new"] && !Shopify.designMode) return;
  try {
    


document.querySelectorAll('.accordian-container .question').forEach(function (question) {
question.addEventListener('click', function () {
// Remove 'active' class from all 'question' elements
document.querySelectorAll('.accordian-container .active').forEach(function (activeElement) {
activeElement.classList.remove('active');
});
this.parentNode.classList.add('active');

var id = this.parentNode.getAttribute('data-id');

// Remove 'active' class from all 'accordian_right_content' elements
document.querySelectorAll('.accordian-image .accordian_right_content').forEach(function (accordianContent) {
accordianContent.classList.remove('active');
});

document.querySelectorAll('.accordian-image.mobile .accordian_right_content').forEach(function (accordianContent) {
accordianContent.classList.remove('active');
});

// Add 'active' class to the corresponding 'accordian_right_content' element
var targetContent = document.querySelector('.accordian-image.desktop .' + id).closest('.accordian_right_content');
if (targetContent) {
targetContent.classList.add('active');
}
var targetContent = document.querySelector('.accordian-image.mobile .' + id).closest('.accordian_right_content');
if (targetContent) {
targetContent.classList.add('active');
}
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-with-image"] && !Shopify.designMode) return;
  try {
    


document.querySelectorAll('.accordian-container .question').forEach(function (question) {
question.addEventListener('click', function () {
// Remove 'active' class from all 'question' elements
document.querySelectorAll('.accordian-container .active').forEach(function (activeElement) {
activeElement.classList.remove('active');
});
this.parentNode.classList.add('active');

var id = this.parentNode.getAttribute('data-id');

// Remove 'active' class from all 'accordian_right_content' elements
document.querySelectorAll('.accordian-image .accordian_right_content').forEach(function (accordianContent) {
accordianContent.classList.remove('active');
});

document.querySelectorAll('.accordian-image.mobile .accordian_right_content').forEach(function (accordianContent) {
accordianContent.classList.remove('active');
});

// Add 'active' class to the corresponding 'accordian_right_content' element
var targetContent = document.querySelector('.accordian-image.desktop .' + id).closest('.accordian_right_content');
if (targetContent) {
targetContent.classList.add('active');
}
var targetContent = document.querySelector('.accordian-image.mobile .' + id).closest('.accordian_right_content');
if (targetContent) {
targetContent.classList.add('active');
}
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icons_swipers"] && !Shopify.designMode) return;
  try {
    


 function waitForSwiper(trigger) {
              var interval = setInterval(function () {
                  if (typeof Swiper != 'undefined') {
                      clearInterval(interval);
                      trigger();
                  }
              })
              setTimeout(function () {
                  clearInterval(interval);
              }, 15000)
          }
  
function reviewSliderhp() {
    var swiper = new Swiper('.icon-with-text-swiper .review_swiper', {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        speed: 5000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false, // Keeps autoplay working after interaction
        },
        breakpoints: {
          768: {
                slidesPerView: 4,
                spaceBetween: 16,
                centeredSlides: false,
                autoplay: false // Disable autoplay for non-mobile devices
            },
          
           
            0: {
                slidesPerView: 1.5,
                spaceBetween: 10,
                centeredSlides: true,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false, // Keeps autoplay working after interaction
                },
                      loop: true
            }
        }
    });
}



  

          waitForSwiper(function () {
           reviewSliderhp();
       
          })
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["source_icon"] && !Shopify.designMode) return;
  try {
    


 function waitForSwiper(trigger) {
              var interval = setInterval(function () {
                  if (typeof Swiper != 'undefined') {
                      clearInterval(interval);
                      trigger();
                  }
              })
              setTimeout(function () {
                  clearInterval(interval);
              }, 15000)
          }
  
function reviewSliderhp() {
    var swiper = new Swiper('.icon-with-text-swiper .review_swiper', {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        breakpoints: {
          768: {
                slidesPerView: 4,
                spaceBetween: 16,
                centeredSlides: false,
                autoplay: false // Disable autoplay for non-mobile devices
            },
          
           
            0: {
                slidesPerView: 1.2,
                spaceBetween: 10,
                loop:true
            }
        }
    });
}



  

          waitForSwiper(function () {
           reviewSliderhp();
       
          })
  
  } catch(e) { console.error(e); }
})();
})();
